// 1.0 DEFINE CONST
const _document = $(document);
const _window = $(window);
const windowWidth = _window.width();
const windowHeight = _window.height();
const html = $('html');
const body = $('body');
const loadingBar = $('#loading-bar');

const screenIsTablet = 1024 >= windowWidth 
	? true : false;
const screenIsMobile = 600 >= windowWidth 
	? true : false;

// 2.0 TOOLS/UTILITIES

const scrollTo = (id) => {
	let scrollContainer = html;
	let scrollOffset = screenIsTablet 
		? 80 
		: 150;
	let scrollPosition = typeof id != 'number'
		? id == 'window'
			? windowHeight
			: ($(id).length) 
				? $(id).offset().top 
				: 0
		: windowHeight*(id/100)

	if(getComputedStyle(html[0]).scrollBehavior === 'smooth') {
		scrollContainer.scrollTop(scrollPosition - scrollOffset);
	} else {
		scrollContainer.animate({
			scrollTop: scrollPosition - scrollOffset
		});
	}
}

const siteReadyTrigger = (punk, delay) => {
	document.addEventListener('readystatechange', event => {
		if (document.readyState == 'complete') {
			(delay) ? setTimeout(punk, delay) : punk();
		}
	});
}

const loadingBarTrigger = (stage) => {
	let action = (loadingBar.css('opacity') == 1 && stage != 'done')
		? 'move' : stage

	switch(action) {
		case 'start':
			loadingBar.css('opacity', 1)
				.width(windowWidth*(Math.floor(Math.random() * 6) + 1)/10);
			break;

		case 'move':
			loadingBar.css('opacity', 1)
				.width(loadingBar.width()*1.15);
			break;

		case 'done':
			loadingBar.width(windowWidth);

			setTimeout(function() {
				loadingBar.css('opacity', 0);
			}, 300);

			setTimeout(function() {
				loadingBar.width(0);
			}, 600);
			break;
	}
}

window.loadingBarTrigger = loadingBarTrigger;

const formatLeadingZero = (value) => { 
	return (value < 10 ? '0' : '') + value;
}

const formatCommify = (value) => {
	return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const retinafy = (img) => {
	(img.attr('src'))
		? (img.attr('src').indexOf('@2x') == -1)
			? new RetinaImage(img[0]) : ''
		: '';
}

$.fn.extend({
	toggleText: function(a, b){
		return this.text(this.text() == b ? a : b);
	}
});

const scrollable = (slider) => {
	let isDown = false;
	let startX;
	let scrollLeft;

	slider.addEventListener('mousedown', (e) => {
		isDown = true;
		startX = e.pageX - slider.offsetLeft;
		scrollLeft = slider.scrollLeft;
	});

	slider.addEventListener('mouseleave', () => {
		isDown = false;
	});
	

	slider.addEventListener('mouseup', () => {
		isDown = false;
	});

	slider.addEventListener('mousemove', (e) => {
		if(!isDown) return;
		e.preventDefault();
		const x = e.pageX - slider.offsetLeft;
		const walk = (x - startX) * 3; //scroll-fast
		slider.scrollLeft = scrollLeft - walk;
	});
}


// 3.0 PAGES/COMPONENTS

const initFields = () => {
	let inputs = $(`.field input[type="text"],
		.field input[type="email"], 
		.field input[type="tel"],
		.field input[type="url"],
		.field input[type="password"],
		.field textarea`);
	let select = $('.field select');

	inputs.on('init blur', function() {
		let _this = $(this);

		(_this.val().length > 0)
			? _this.closest('.field').addClass('has_value') 
			: _this.closest('.field').removeClass('has_value');
	});

	siteReadyTrigger(function() {
		inputs.trigger('init');
	});

	select.on('change', function() {
		let _this = $(this);

		_this.closest('.field').addClass('has_value');
	});
}

const initNewsletter = () => {
	const newsletterForm = $('#footer-content-connect form');
	const newsletterFormEmail = newsletterForm.find('[type="email"]');

	const validateEmail = (email) => {
		let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
		return regex.test(email);
	}

	const submitSuccess = () => {
		newsletterForm.addClass('success')
			.find('h2').text('Thanks for subscribing!');

		setTimeout(function() {
			newsletterForm.find('h2').after(`<p class="t-b-3">
				You’re now subscribed! You should receive a confirmation email shortly.
			</p>`).fadeIn();
		}, 300);
	}

	newsletterForm.submit(function(e) {
		let _this = $(this);

		if(!newsletterFormEmail.val() || 
			!validateEmail(newsletterFormEmail.val())) {
			e.preventDefault();

			_this.find('.field').addClass('error');
		} else {
			$.ajax({
				type: 'POST',
				async: true,
				url: _this.attr('action'),
				data: _this.serialize(),
				beforeSend: function() {
					loadingBarTrigger('start');
				},
				error: function(error) {
					if(error.status != 429) {
						e.preventDefault();
					}
				},
				success: function(response) {
					e.preventDefault();
					submitSuccess(_this);
				}
			}).always(function() {
				loadingBarTrigger('done');
			});
		}
	});

	if(window.location.href.indexOf('newsletter&form_type=customer') != -1 || 
		window.location.href.indexOf('?customer_posted=true') != -1) {
		scrollTo('#footer');
		submitSuccess();
	}
}

const initCurrencySelector = () => {
	const currencySelector = $('.currency-selector');

	currencySelector.change(function() {
		html.addClass('is_leaving');
		$(this).closest('form').submit();
	});
}

const initPageTransition = () => {
	let siteUrl = shopUrl.replace('www.', '').replace('http://', '').replace('https://', '');

	$('a[href]').each(function(){
		let _this = $(this);
		let href = _this.attr('href');

		if((href.includes(siteUrl) || href.startsWith('/')) && 
			_this.attr('target') != '_blank' && !href.includes('mailto:')) {
			_this.attr('data-location', 'internal');

		} else {
			_this.attr('data-location', 'external')
		}
	});

	_document.on('click', 'a[href]', function(e) {
		let _this = $(this);
		let href = _this.attr('href');
		let hrefSplitHash = href.split('#');
		let windowHrefSplitHash = window.location.href.split('#');

		// if hash origin url is current url
		if(href != '#contact' &&
			href != '#' && 
			(href.startsWith('#') || 
			hrefSplitHash[0] == windowHrefSplitHash[0]) || 
			hrefSplitHash[0] == window.location.href.replace(shopUrl, '').split('#')[0]) {
			e.preventDefault();

			// scroll to hash location
			scrollTo(`#${hrefSplitHash[1]}`);

			html.removeClass('slide_pane_active');

		} else if(_this.attr('data-location') == 'internal' &&
			keyOnPress == false) {
			e.preventDefault();

			html.addClass('is_leaving')
				.removeClass('slide_pane_active');

			setTimeout(function() {
				window.location.href = href;
			}, 300);

			setTimeout(function() {
				html.removeClass('mobile_navigation_active slide_pane_active');
			}, 600);
		}
	});
}

const initPageAnimation = () => {
	const animationScroll = () => {
		const scrollTopOffsetAni = scrollTop + windowHeight*0.8

		// get all anchor with top offset
		$('[data-ani-anchor]:not([data-ani-anchor="onload"])').each(function() {
			let _this = $(this);

			if(scrollTopOffsetAni > parseInt(_this.offset().top) &&
				!_this.hasClass('animate')) {
				_this.addClass('animate')
			}
		});
	}

	$('[data-ani-anchor="onload"]').each(function() {
		$(this).addClass('animate');
	});

	animationScroll();
	_window.scroll(animationScroll);
}

const initHeader = () => {
	const header = $('#header');
	const headerNav = $('.header-nav');
	const slidePane = $('[data-slide-pane-content]');
	const slidePaneDuration = 900;
	const slidePaneFadeDuration = 300;
	const slideTrigger = $('[data-slide-pane-trigger]');
	const slideClose = $('.slide-pane-close');
	const slideOverlay = header.find('#slide-pane-overlay');
	slideClosingActionAlpha = slideClosingActionBeta =
	slideOverlayClickable = null;

	slideTrigger.on('click mouseenter', function(e) {
		let _this = $(this);
		let paneName = _this.attr('data-slide-pane-trigger');
		let paneActive = $(`[data-slide-pane-content="${paneName}"]`);
		let panePreviousActive = $('[data-slide-pane-content].active');
		let paneActionMatch = paneActive.attr('data-slide-pane-direction') == panePreviousActive.attr('data-slide-pane-direction')

		// if is mouseover and -
		if(e.type == 'mouseenter' && 
			// no slide pane is active, or pane action is not the same
			(!panePreviousActive.length || !paneActionMatch || paneName == panePreviousActive.attr('data-slide-pane-content'))) {
			// do nuffin and exit out of function
			return;
		}

		if(e.type == 'click' && _this.hasClass('active')) {
			return;
		}

		// stop slide closing action
		clearTimeout(slideClosingActionAlpha);
		clearTimeout(slideClosingActionBeta);
		clearTimeout(slideOverlayClickable);
		slideOverlay.css('pointer-events', 'none');

		// assign active state for root
		html.addClass('slide_pane_active');

		// assign active state for nav group
		headerNav.removeClass('active');
		_this.closest('.header-nav').addClass('active');

		// assign active state for link
		slideTrigger.removeClass('active');
		_this.addClass('active');

		// assign active state for pane
		setTimeout(function() {
			html.attr('data-slide-pane-active', paneName);
			paneActive.addClass('active');
		}, (paneActionMatch || !panePreviousActive.length) ? 0 : slidePaneDuration );

		if(panePreviousActive.length && paneActionMatch) {
			paneActive.addClass('active-fadeIn');

			// move current active slide pane to a layer beneath
			panePreviousActive.css({
				'transition': '0s',
				'z-index': 109
			});

			setTimeout(function() {
				// remove current active pane after 0.6 seconds (fade in duration)
				panePreviousActive.removeClass('active active-fadeIn');
			}, slidePaneFadeDuration);

			setTimeout(function() {
				// restore current active slide pane z-index and transition
				panePreviousActive.removeAttr('style');
			}, slidePaneFadeDuration*2);
		} else {
			panePreviousActive.removeClass('active active-fadeIn');
		}

		// make overlay mouse entera-ble for closure
		slideOverlayClickable = setTimeout(function() {
			slideOverlay.css('pointer-events', 'auto');
			// only after slide pane has came in
		}, (!paneActionMatch && panePreviousActive.length) 
			? slidePaneDuration*2 : slidePaneDuration);

		// pane specific functions

		switch(paneName) {
			case 'header-actions-search':
				setTimeout(function() {
					$('#header-search-form input[type="text"]').focus();
				}, slidePaneDuration);
				break;
		}
	});

	const slidePaneClose = () => {
		slideClosingActionAlpha = setTimeout(function() {
			html.removeClass('slide_pane_active');
			slidePane.removeClass('active active-fadeIn');
			slideTrigger.removeClass('active');
			slideOverlay.css('pointer-events', 'none');
		}, 0);

		slideClosingActionBeta = setTimeout(function() {
			headerNav.removeClass('active');

			switch(html.attr('data-slide-pane-active')) {
				case 'header-actions-search':
					$('#header-search-form').trigger('clearSearch');

				case 'header-actions-contact':
					$('[data-pane-switch-trigger="menu"]').click();
			}

			html.removeAttr('data-slide-pane-active');
		}, slidePaneDuration);

		history.pushState(null, null, ' ');
	}

	slideOverlay.on('click', slidePaneClose);
	slideClose.click(slidePaneClose);

	// contact pane switching
	let contactPaneMenu = $('[data-pane-switch="menu"]');

	$('[data-pane-switch-trigger="email"]').click(function() {
		contactPaneMenu.removeClass('active');
	});

	$('[data-pane-switch-trigger="menu"]').click(function() {
		contactPaneMenu.addClass('active');
	});

	// hash url to auto trigger contact form open
	const contactPaneTrigger = () => {
		$('#slide-pane-overlay').css('pointer-events', 
			'none !important');
		$('[data-slide-pane-trigger="header-actions-contact"]').click();
		$('[data-pane-switch-trigger="email"]').click();

		if(screenIsTablet) {
			html.addClass('mobile_navigation_active');
		}
	}

	if(window.location.hash == '#contact' && 
		html.is('#page-customer-service')) {
		contactPaneTrigger();
	}

	$('[href="#contact"]').click(function(e) {
		e.preventDefault();

		contactPaneTrigger();
	});

	let contactForm = $('[data-slide-pane-content="header-actions-contact"] #contact_form');

	const contactFormSuccess = () => {
		contactForm.fadeOut();

		setTimeout(function() {
			contactForm.parent().append(`
				<div 
					id="contact-form-success"
					class="form-success">
				Thank you. Your message has been sent.</div>
			`).fadeIn();
		}, 300);
	}

	contactForm.submit(function(e) {
		$.ajax({
			type: 'POST',
			async: true,
			url: '/contact',
			data: contactForm.serialize(),
			beforeSend: function() {
				loadingBarTrigger('start');
			},
			error: function(error) {
				if(error.status != 429) {
					e.preventDefault();
				}
			},
			success: function(response) {
				e.preventDefault();
				contactFormSuccess();
			}
		}).always(function() {
			loadingBarTrigger('done');
		});
	});

	if(window.location.href.indexOf('?contact_posted=true') != -1) {
		scrollTo('window');
		contactPaneTrigger();
		contactFormSuccess();
	}

	// frontpage header state
	const frontpageScroll = () => {
		if(scrollTop > windowHeight/2) {
			html.addClass('frontpage_header_reveal');
		} else {
			html.removeClass('frontpage_header_reveal');
		}
	}
	frontpageScroll();
	_window.scroll(frontpageScroll);

	// responsive mobile menu
	const mobileNavigationTrigger = $('#mobile-navigation-trigger');

	mobileNavigationTrigger.click(function() {
		(html.hasClass('mobile_navigation_active') ||
			html.attr('data-slide-pane-active') == 'header-actions-cart')
			? (html.hasClass('slide_pane_active'))
				? slidePaneClose()
				: html.removeClass('mobile_navigation_active')
			: html.addClass('mobile_navigation_active');
	});
}

const initSearchPane = () => {
	if(screenIsTablet) {
		$('#mobile-navigation-search').append($('#header-search-content').html());

		$('#header-search-input').attr('placeholder', 'Search')

		$('#header-search-content').remove();
	}

	const searchForm = $('#header-search-form');
	const searchInput = searchForm.find('input[type="text"]');
	const searchClear = searchForm.find('#header-search-clear');
	const searchResults = $('#header-search-results');
	collectionSearchRequest = productSearchRequest = searchInputThrottle = null;

	const searchReset = () => {
		searchInput.val('');
		searchResults.empty();
		searchForm.removeClass('has_value');

		loadingBarTrigger('done');
	}

	const searchResultsTrigger = () => {
		clearTimeout(searchInputThrottle);

		searchInputThrottle = setTimeout(function() {
			let term = searchInput.val();
			let collectionSearchUrl = `https://worldofauteur.com/search?type=collection&q=${term}`;
			let productSearchUrl = `https://worldofauteur.com/search?type=product&q=${term}`;

			if(term.length >= 3 && 
				term != searchInput.attr('data-term')) {
				// add active state
				searchForm.addClass('has_value');

				// register search term to avoid double triggering ajax
				searchInput.attr('data-term', term);

				// start loading state
				loadingBarTrigger('start');

				// if abort current ajax request, if exists
				(collectionSearchRequest !== null) 
					? collectionSearchRequest.abort() : '';

				(productSearchRequest !== null) 
					? productSearchRequest.abort() : '';

				// trigger ajax request
				collectionSearchRequest = $.getJSON(collectionSearchUrl + '&view=json')
				.always(function(data) {
					searchCollectionResults = '';

					if(data.results_count > 0) {
						searchCollectionResults += `<div class="t-l">Collections</div>
							<ul id="search-collection-list" class="t-b-3">`;

							$.each(data.results, function(i, item) {
								if(i < 4 && !item.url.includes('/pages/')) {
									searchCollectionResults += `<li>
										<a href="${item.url}">${item.title}</a>
									</li>`;
								}
							});

						searchCollectionResults += `</ul>`;
					}
				});

				productSearchRequest = $.getJSON(productSearchUrl + '&view=json')
				.always(function(data) {
					searchProductResults = '';

					if(data.results_count > 0) {
						searchProductResults += `<div class="t-l">Products</div>
							<div 
								id="search-product-grid" 
								class="g-flex">`;

							$.each(data.results, function(i, item) {
								if(i < 4) {
									searchProductResults += `<div 
										class="search-product g-flex g-center">
										<a href="${item.url}" title="${item.title}"></a>
										<div class="search-product-thumbnail product-thumbnail">
											${(!item.thumbnail.includes('no-image'))
												? `<span class="object-contain">
													<img 
														src="${item.thumbnail}" 
														alt="${item.title}">
													</span>`
												: ''
											}
										</div>
										<div class="search-product-content">
											<div class="t-h-6">${item.title}</div>
											<div class="t-b-2">${item.price}</div>
										</div>
									</div>`;
								}
							});

							if (data.results_count > 4) {
								searchProductResults += `<div id="search-product-more">
									<a class="btn" href="${productSearchUrl}">See all ${data.results_count} results</a>
								</div>`;
							}

						searchProductResults += `</div>`;
					}
				});

				$.when( collectionSearchRequest, productSearchRequest )
				.done(function() {
					loadingBarTrigger('done');

					// no collection searching capability at this stage
					searchCollectionResults = '';

					searchResults.html(`${
						(searchCollectionResults == '' 
							&& searchProductResults == '')
							? `<div id="search-product-no-results">
								<div class="t-b-2 cr-gray-d">No results for your search term.</div>
							</div>` 
							: searchCollectionResults + searchProductResults
					}`);
				});

			} else if (term.length == 0) {
				searchReset();
			}
		}, 450);
	}
	searchInput.on('keyup change', searchResultsTrigger);

	searchForm.on('submit', function(e) {
		e.preventDefault();

		window.location.href = `https://worldofauteur.com/search?type=product&q=${searchInput.val()}`;
	}).on('clearSearch', searchReset);

	searchClear.on('click', function(e) {
		e.preventDefault();

		searchReset();
	});
}

const initFrontpage = () => {
	const heroIframe = $('#frontpage-hero-iframe');

	if(heroIframe.length) {
		const heroPlayer = new Vimeo.Player(heroIframe[0]);

		heroPlayer.on('play', function() {
			heroIframe.addClass('css_fadeIn');
		});

		setTimeout(function() {
			heroIframe.addClass('css_fadeIn');
		}, 3000);
	}
}

const initProductIndex = () => {
	const collectionProducts = $('#collection-products');
	const collectionProductsCount = $('#collection-hero-product-count');

	// product loading
	const collectionProductsInfiniteScroll = () => {
		collectionProducts.infinitescroll({
			errorCallback: function() {
				html.addClass('collection_load_end');

				loadingBarTrigger('done');
			}
		}, function(i) {
			$(i).addClass('css_fadeIn animate');

			loadingBarTrigger('done');

			(html.hasClass('screen_is_retina'))
				? retinafy($(i).find('img')) : '';
		});		
	}

	collectionProductsInfiniteScroll();

	_window.unbind('.infscr');
	_document.on('click', '#collection-load-more', function() {
		loadingBarTrigger('start');
		collectionProducts.infinitescroll('retrieve');
		$('#infscr-loading').remove();
	});

	// product filtering
	const toolbarMobile = $('#collection-toolbar-mobile');
	const toolbarMobileFilter = toolbarMobile.find('#collection-toolbar-mobile-filter');

	if(screenIsMobile) {
		toolbarMobile.find('#collection-toolbar-mobile-filter')
			.prepend($('#collection-toolbar-filter').html());
	}

	if(windowHeight - collectionProducts.offset().top > collectionProducts.height()) {
		html.addClass('is_toolbar_mobile_absolute');
	}

	const toolbar = (!screenIsMobile)
		? $('#collection-toolbar')
		: toolbarMobile;
	const toolbarContent = toolbar.find('#collection-toolbar-content');
	const toolbarDropdown = toolbar.find('.toolbar-dropdown');
	const toolbarDropdownTrigger = toolbar.find('[data-dropdown-trigger]');
	const toolbarDropdownOverlay = toolbar.find('#collection-toolbar-dropdown-overlay');
	
	

	// toggle filter/sort dropdowns
	const toolbarDropdownClose = () => {
		if(toolbar.find('.toolbar-dropdown.active')) {
			html.removeClass('toolbar_active');
			toolbar.find('.toolbar-dropdown.active').removeClass('active')
			toolbarDropdownOverlay.height(toolbarContent.height() + 10);
		}
	}

	toolbarDropdownTrigger.click(function() {
		let dropdownActive = $(this).closest('.toolbar-dropdown');

		if(dropdownActive.hasClass('active')) {
			toolbarDropdownClose();
		
		} else {
			html.addClass('toolbar_active');
			toolbarDropdown.removeClass('active');
			dropdownActive.addClass('active');
			toolbarDropdownOverlay.height(toolbarContent.height() + 
				dropdownActive.find('ul').innerHeight());
		}
	});

	toolbar.on('mouseleave', toolbarDropdownClose);

	// toolbar and product filtering/sorting
	const toolbarCurrent = $('#collection-toolbar-current');
	collectionProductRequest = null;

	const collectionToolbarRefresh = () => {
		let urlParams = new URLSearchParams(window.location.search);
		let urlParamsSort = urlParams.get('sort_by');

		// determine active state for sort
		if(urlParamsSort && urlParamsSort != 'manual') {
			toolbar.find(`[data-sort-trigger="${urlParamsSort}"]`).closest('li').addClass('active')
				.siblings().removeClass('active');
		}

		// determine active filters
		let filterActiveTerms = [];

		toolbar.find(`li.active [data-filter-trigger]`).each(function() {
			filterActiveTerms.push($(this).attr('data-filter-trigger'));
		});

		// if has terms
		if(filterActiveTerms.length) {
            const lang = document.getElementById('collection-toolbar-current');
			let clearBtn = 'Clear All'
			if (lang.getAttribute('data-lang') === 'deutsch'){
				clearBtn = 'Alles löschen'
			}
			// create toolbar current HTML
			toolbarCurrent.html(`
				<ul>${filterActiveTerms.map(item => 
					`<li>
						<button 
							class="t-l" 
							data-filter-clear-trigger="${item}">${item.replace('Focus_', '').replace('Category_', '')}</button>
					</li>`
				).join('')}</ul>

				<button 
					class="t-l" 
					data-filter-clear-trigger="all">${clearBtn}
				</button>
			`);
		} else {
			// else, clear toolbar
			toolbarCurrent.empty();
		}
	}

	const collectionProductRefresh = () => {
		// trigger fade in for all sections due to the shift in product grid height
		$('[data-ani-anchor]:not(.animate)').addClass('animate');

		// if abort current ajax request, if exists
		(collectionProductRequest !== null) 
			? collectionProductRequest.abort() : '';

		// initiate loading bar
		loadingBarTrigger('start');

		// fade out product grid
		collectionProducts.addClass('css_fadeOut')
			.removeClass('css_fadeIn');

		// generate filter URL
		let filterActiveTerms = [];
		let sortActiveTerm = $('li.active [data-sort-trigger]').attr('data-sort-trigger');

		$('li.active [data-filter-trigger]').each(function() {
			filterActiveTerms.push($(this).attr('data-filter-trigger')
				.replace(/\s+/g, '-').toLowerCase());
		});

		let filterUrl = `${collectionUrl}/${
			(filterActiveTerms.length) ? filterActiveTerms.join('+') : ''}${
			(sortActiveTerm && sortActiveTerm != 'manual') ? `?sort_by=${sortActiveTerm}` : ''}`;

		// trigger ajax request for products
		collectionProductRequest = $.ajax({
			url: filterUrl,
			context: document.body
		}).done(function(data) {
			// update URL
			history.pushState({}, '', filterUrl);

			// refresh toolbar
			collectionToolbarRefresh();

			// replace products
			if($(data).find('#collection-products').length) {
				collectionProducts.html($(data).find('#collection-products').html());

				$('#collection-products [data-ani-anchor]').addClass('animate');

				// if retina, update image
				if(html.hasClass('screen_is_retina')) {
					retinafy($('#collection-products img'));
				}
			} else {
				let emptyCollectionHtml = $(data).find('#collection-empty');

				emptyCollectionHtml.find('p').html('There are no items matching your filters – reset the filters or try a different category to continue.')
				.after(`<button 
					class="btn-block btn-outline cr-gold" 
					data-filter-clear-trigger="all">
					Reset Filters</button>`);

				collectionProducts.html(`<div id="collection-empty">
					${emptyCollectionHtml.html()}
				</div>`);
			}

			// fade in product grid
			collectionProducts.addClass('css_fadeIn')
				.removeClass('css_fadeOut');

			// determine if load more is needed
			if($(data).find('#collection-load-more').length) {
				// if load more button already exists
				if($('#collection-load-more').length) {
					// show load more button
					$('#collection-load-more').show();
					// and update load url
					$('#infinite-next a').attr('href', $(data).attr('href'));
				} else {
					// else, grab from new page
					collectionProducts.after(`
						${$(data).find('#collection-load-more').prop('outerHTML')}
						${$(data).find('#infinite-next').prop('outerHTML')}
					`);
				}

				collectionProductsInfiniteScroll();
			} else {
				$('#collection-load-more').hide();
			}

			// update product counts
			let productLength = collectionProducts.find('.comp-product-card').length;

			collectionProductsCount.text(`${productLength}${
				($(data).find('#collection-load-more').length) 
					? '+' : ''
				} Item${
					(productLength > 1) ? 's' : ''
			}`)

			// end loading bar
			loadingBarTrigger('done');

			// scroll to top on tablet
			(screenIsTablet)
				? scrollTo('#collection-hero-content') : '';
		});
	}

	// reset toolbar on load
	collectionToolbarRefresh();

	_document.on('click', '[data-filter-trigger]', function() {
		$(this).closest('li').toggleClass('active')
			.siblings().removeClass('active');

		if(!screenIsMobile) {
			collectionProductRefresh();
			toolbarDropdownClose();
		}
	});

	_document.on('click', '[data-sort-trigger]', function() {
		$(this).closest('li').toggleClass('active')
			.siblings().removeClass('active');

		collectionProductRefresh();

		if(!screenIsMobile) {
			toolbarDropdownClose();
		}
	});

	_document.on('click', '[data-filter-clear-trigger]', function() {
		let term = $(this).attr('data-filter-clear-trigger');

		(term == 'all') 
			// clear all filtering
			? $('li.active [data-filter-trigger]').closest('li.active').removeClass('active')

			// clear individual filter
			: $(`li.active [data-filter-trigger="${term}"]`).closest('li')
				.removeClass('active');

		collectionProductRefresh();
	});

	toolbarMobile.find('#collection-toolbar-mobile-filter-trigger').click(function() {
		html.addClass('toolbar_mobile_filter_active');
		document.getElementById('smile-ui-container').style.display = 'none'
		document.getElementById('footer').style.zIndex = '-1'
	});

	toolbarMobile.find('#collection-toolbar-mobile-filter-cancel').click(function() {
		html.removeClass('toolbar_mobile_filter_active')
		document.getElementById('smile-ui-container').style.display = 'block'
		document.getElementById('footer').style.zIndex = '1'
	});

	toolbarMobile.find('#collection-toolbar-mobile-filter-apply').click(function() {
		html.removeClass('toolbar_mobile_filter_active');
		collectionProductRefresh();
	});

	toolbarMobile.find('#collection-toolbar-mobile-sort-trigger').change(function() {
		html.removeClass('toolbar_mobile_filter_active');

		$(`[data-sort-trigger="${toolbarMobile.find('#collection-toolbar-mobile-sort-trigger').val()}"]`).click();
	});

	const toolbarMobileScroll = () => {
		let toolbarScrollTop = scrollTop + windowHeight - 60;
		let footerTop = $('#footer').offset().top;

		toolbarMobile.css('opacity', 
			(toolbarScrollTop >= footerTop) ? 0 : 1);
	}

	toolbarMobileScroll();
	_window.scroll(toolbarMobileScroll);
}

const initProductSingle = () => {
	// sticky product form
	const productSingleScroll = () => {
		(scrollTop > $('#product-hero').height()) 
			? html.addClass('product_sticky_form_reveal')
			: html.removeClass('product_sticky_form_reveal');
	}
	productSingleScroll();
	_window.scroll(productSingleScroll);

	// hero section
	let heroVideo = $('#product-hero-image .video');

	if(screenIsMobile && heroVideo.length) {

		$('#product-hero-content-interior').append(heroVideo.clone());

		heroVideo.remove();
	}

	const videoIframe = $('#product-hero iframe');

	if(videoIframe.length) {
		const videoIframePlayer = new Vimeo.Player(videoIframe[0]);

		videoIframePlayer.on('play', function() {
			videoIframe.addClass('css_fadeIn');
		});

		setTimeout(function() {
			videoIframe.addClass('css_fadeIn');
		}, 3000);
	}

	$('#product-hero-description-more-trigger').click(function() {
		let _this = $(this);

		_this.toggleText('Read More +', 'Read Less -')
			.siblings('#product-hero-description-more').slideToggle();
	});

	// product form
	const formButtonAdd = $('.product-form-add');
	const formButtonBuy = $('.product-form-buy');
	const formVariants = $('.product-form-variants');
	const formVariantsInput = formVariants.find('input[name="variant"]');
	const formVariantsTrigger = $('.product-form-variants-trigger');

	formVariantsTrigger.click(function(e) {
		e.preventDefault();

		$(this).closest('.product-form-variants').toggleClass('active');
	});

	_window.on('click', function(e) {
		let target = $(e.target);

		if(!target.hasClass('product-form-variants') && 
			!target.closest('.product-form-variants').length) {
			$('.product-form-variants').removeClass('active');
		}
	});

	formVariantsInput.change(function() {
		let _this = $(this);

		// assign active state to variant options
		formVariantsInput.each(function() {
			let input = $(this);

			if(input.attr('data-variant-id') == _this.attr('data-variant-id')) {
				input.prop('checked', true)
					.closest('li').addClass('active')
					.siblings().removeClass('active').prop('checked', false);
			}
		});

		$('select[name="id"]').val(_this.attr('data-variant-id'));

        const isComingSoon = _this.closest('[data-coming-soon]').data('coming-soon');

        let atcText = 'Buy Now'
        let atcDisabled = false;
        if (isComingSoon) {
          formButtonAdd.html(`Coming Soon <span class="product-price"></span>`).prop('disabled', true);
          formButtonBuy.html('Coming Soon').prop('disabled', true);
        }
        else if (_this.data('inventory') <= 0) {
          formButtonAdd.html('Sold Out').prop('disabled', true);
          formButtonBuy.html('Sold Out').prop('disabled', true);
        } 
        else {
          formButtonAdd.html(`Add to Bag <span class="product-price"></span>`).prop('disabled', false);
          formButtonBuy.html('Buy Now').prop('disabled', false);
        }
      
		// update pricing 
		$('.product-price').text(_this.attr('data-price'));

		$('.product-price-full').html(`${
			(_this.attr('data-compare-price'))
				? `<s class="cr-gray"><span class="price">${_this.attr('data-compare-price')}</span></s>
					<span class="product-price price cr-gold">${_this.attr('data-price')}</span>`
				: `<span class="product-price price">${_this.attr('data-price')}</span>`
			}`
		);
	});

	formButtonBuy.click(function(e) {
		e.preventDefault();
		loadingBarTrigger('start');

		$.post('/cart/clear.js').always(function() {
			$.ajax({
				type: 'POST',
				dataType: 'html',
				url: `/cart/add.js`,
				data: {
					id: formVariants.find('input:checked').val(),
					quantity: 1
				},
				success: function(data) {
					loadingBarTrigger('done');

					html.addClass('is_leaving');

					window.location.href = '/cart/checkout';
				}
			});
		});
	});

	// ingredients section
	const ingredientSlider = $('#product-ingredients-slider')
	const ingredientSliderSlide = ingredientSlider.find('.slide');
	const ingredientSliderSlideLength = ingredientSliderSlide.length;
	const ingredientSliderPagination = $('#product-ingredients-slider-pagination');
	const ingredientSliderPaginationButton = ingredientSliderPagination.find('button');
	const ingredientSliderPaginationCurrent = ingredientSliderPagination.find('#slider-pagination-current');

	// if multiple slides exists
	if(!screenIsMobile) {
		if(ingredientSliderSlideLength > 1) {
			ingredientSliderPagination.show();

			// set slider min height (so that it doesn't move too drastically: .e.g 2 rows to 1 row)
			siteReadyTrigger(function() {
				ingredientSlider.css({
					'min-height': ingredientSlider.height()
				});
			}, 300);

			// set current and total slide # in pagination
			ingredientSliderPagination.find('#slider-pagination-total')
				.text(formatLeadingZero(ingredientSliderSlideLength));

			ingredientSliderPaginationButton.click(function() {
				let paginate = $(this).attr('data-paginate');
				let currentSlideIndex = ingredientSlider.find('.active').index();
				let activeSlideIndex = (paginate == 'next')
					? currentSlideIndex < ingredientSliderSlideLength - 1
						? currentSlideIndex + 1
						: 0
					: currentSlideIndex == 0
						? ingredientSliderSlideLength - 1
						: currentSlideIndex - 1

				$(ingredientSliderSlide[activeSlideIndex]).addClass('active')
					.siblings().removeClass('active');

				// update current slide # in pagination
				ingredientSliderPaginationCurrent.text(formatLeadingZero(activeSlideIndex + 1));
			});
		}
	} else {
		ingredientSliderSlide.children().unwrap();
	}

	// ingredients all panel
	$('#ingredients-all-trigger').click(function() {
		html.addClass('ingredients_all_active');
	});

	$('#ingredients-all-close, #ingredients-all-overlay').click(function() {
		html.removeClass('ingredients_all_active');
	});

	// reviews section
	const productReviews = $('#product-reviews');
	const reviewsContent = $('#product-reviews-content');
	const reviewsContentTrigger = $('#product-reviews-content-trigger');

	reviewsContentTrigger.click(function() {
		if(productReviews.hasClass('has_reviews')) {
			reviewsContentTrigger.toggleText('See all reviews +', 'Hide reviews -');
		}

		reviewsContent.slideToggle();
	});

	siteReadyTrigger(function() {
		// remove review submissions if customer is not logged in
		if(!productReviews.hasClass('has_customer_profile')) {
			$(`.spr-header, 
				.spr-form`).remove();

			if(!productReviews.hasClass('has_reviews')) {

				$('#product-reviews-content-trigger').text('Log in to write a review').click(function(e) {
					e.preventDefault();

					window.location.href = '/account/login';
				});
			}
		}

		// HTML modifications
		$(`.spr-header .spr-header-title, 
			.spr-header .spr-summary-starrating, 
			.spr-header .spr-summary-caption`).remove();

		$('.spr-summary-actions-newreview').addClass('btn-block');

		$('.spr-form-title').addClass('t-h-5');

		$(`.spr-form-contact-name, 
			.spr-form-contact-email, 
			.spr-form-review-rating, 
			.spr-form-review-title, 
			.spr-form-review-body`).addClass('field').each(function() {
			let field = $(this);
			let label = field.find('label');
			let inputs = field.find('input, textarea');

			if(!field.is('.spr-form-review-body') &&
				!field.is('.spr-form-review-rating')) {
				field.append(label);
			}

			inputs.attr('placeholder', '');

			inputs.on('blur', function() {
				let _this = $(this);

				(_this.val().length > 0)
					? _this.closest('.field').addClass('has_value') 
					: _this.closest('.field').removeClass('has_value');
			});
		});

		$('.spr-button-primary').addClass('btn-block');
	}, 1000);
}

const initCart = () => {
	const cartTrigger = $('[data-slide-pane-trigger="header-actions-cart"]');
	const cartClose = $('.cart_close');
	const cartActionsCheckout = $('#cart-actions-checkout');

	const excludeProductDiscover = () => {
		// reveal all products on load
		$('[data-product-discover-id]').removeClass('inactive');

		// loop through all products in cart
		$('[data-product-id]').each(function() {
			// remove discover products with matching ID
			$(`[data-product-discover-id="${$(this).attr('data-product-id')}"]`).addClass('inactive');
		});

		(!$('[data-product-discover-id]:not(.inactive)').length)
			? $('#cart-discover, #slide-cart-discover').addClass('inactive')
			: $('#cart-discover, #slide-cart-discover').removeClass('inactive');
	}

	const cartTotalUpdate = () => {
		let totalPrice = $('.cart-total-price');
		let itemCount = $('.cart-item-count-number');
		let item = (html.is('#cart'))
			? $('#cart-content .item')
			: $('#slide-cart-content .item')

		totalPriceChange = 0;
		totalItemCount = 0;
      	var moneyFormate = $(document).find('#money-formate').data('money');

		// loop through each item
		// $('#slide-cart-content .item')
		item.each(function() {
			let item = $(this);
			let itemQuantity = parseInt(item.find('.item-info-quantity option:checked').val());

			// multiply price and quantity, and add to total value
          	var itemPrice =  item.data('item-price');
          	var regex = /[.,\s]/g;
			var $itemPrice = itemPrice.replace(regex, ''); // Replaces all spaces with hyphens.
		//	console.log($itemPrice);
			var itemLinePrice = parseInt($itemPrice)*itemQuantity;
          
          /*
            if (itemPrice.indexOf(".00") >= 0){
              itemLinePrice = itemLinePrice*100;
            }
            */
          
		//	item.find('.item-info-price').text(`$${formatCommify(itemLinePrice)}`);
			item.find('.item-info-price').text(Shopify.formatMoney(itemLinePrice,moneyFormate));
			totalPriceChange += itemLinePrice;
			totalItemCount += itemQuantity;
		});

		// update cart total values
		//totalPrice.text(`$${formatCommify(totalPriceChange)}`);
		totalPrice.text(Shopify.formatMoney(totalPriceChange,moneyFormate));
		itemCount.text(totalItemCount);

		// remove cart content to reveal empty message
		if(totalItemCount == 0) {
			$('#slide-cart-content, #cart-content').remove();

			history.pushState(null, null, ' ');
		}

		excludeProductDiscover();
	}

	const itemUpdate = (variantId, qty, funk) => {
		$.post(`/cart/update.js?updates[${variantId}]=${qty}`)
			.always(function() {
				if(funk) {
					funk();
					loadingBarTrigger('move');
				} else {
					setTimeout(cartTotalUpdate, 301);
					loadingBarTrigger('done');
				}
			});
	}

	const itemAdd = (variantId, qty, openCart, reloadPage) => {
        const langCart = document.getElementById('cart-header');
		let subtotalText = 'Subtotal'
		let infoText = 'Shipping & taxes calculated at checkout'
		let btnText = 'Proceed to checkout'
		if (langCart.getAttribute('data-lang') === 'deutsch'){
			subtotalText = 'Zwischensumme';
			infoText = 'Versand und Steuern werden beim Auschecken berechnet';
			btnText = 'Zur Kasse gehen';
		}

		$.ajax({
			type: 'POST',
			dataType: 'html',
			url: `/cart/add.js`,
			data: {
				id: variantId,
				quantity: qty
			},
			success: function() {
				refreshCart(openCart, reloadPage);
			}
		});
	}

	const bulkAdd = (itemsArray) => {
		$.ajax({
			type: 'POST',
			dataType: 'html',
			url: `/cart/add.js`,
			data: {
				items: itemsArray
			},
			success: function() {
				$.ajax({
					url: '/cart',
					dataType: 'html',
					error: function(data) {
						console.error(data);
					},
					success: function(data) {
						let slideCartContent = $('[data-slide-pane-content="header-actions-cart"] .slide-pane-content');
						let slideCartHtml = `
							<div id="slide-cart-header" class="g-flex">
								<div id="slide-cart-header-left">
									<div class="t-b-2">Subtotal</div>
									<div class="t-b-3 cr-gray-d">Shipping & taxes calculated at checkout</div>
								</div>
								<div id="slide-cart-header-right">
									<span class="cart-total-price t-b-1 price">{{ cart.total_price | money }}</span>
								</div>
								<a 
									href="${shopUrl}/checkout"
									class="btn-block">
									Proceed to checkout</a>
							</div>

							<div id="cart-items">
								${$(data).find('#cart-content #cart-items').html()}
							</div>
						`;

						($('#slide-cart-content').length)
							? slideCartContent.find('#slide-cart-content').html(slideCartHtml)
							: slideCartContent.prepend(`<div id="slide-cart-content" class="g-flex g-vertical">${slideCartHtml}</div>`);

						cartTotalUpdate();

						loadingBarTrigger('done');

						$('#slide-pane-overlay').unbind('mouseenter mousemove');
					}
				});
			}
		});
	}

	const refreshCart = (openCart, reloadPage, callback) => {
        const langCart = document.getElementById('cart-header');
		let subtotalText = 'Subtotal'
		let infoText = 'Shipping & taxes calculated at checkout'
		let btnText = 'Proceed to checkout'
		if (langCart.getAttribute('data-lang') === 'deutsch'){
			subtotalText = 'Zwischensumme';
			infoText = 'Versand und Steuern werden beim Auschecken berechnet';
			btnText = 'Zur Kasse gehen';
		}
		$.ajax({
			url: '/cart',
			dataType: 'html',
			error: function(data) {
				console.error(data);
			},
			success: function(data) {
				let slideCartContent = $('[data-slide-pane-content="header-actions-cart"] .slide-pane-content');
				let slideCartHtml = `
					<div id="slide-cart-header" class="g-flex">
						<div id="slide-cart-header-left">
							<div class="t-b-2">${subtotalText}</div>
							<div class="t-b-3 cr-gray-d">${infoText}</div>
						</div>
						<div id="slide-cart-header-right">
							<span class="cart-total-price t-b-1 price">{{ cart.total_price | money }}</span>
						</div>
						<a 
							href="${shopUrl}/checkout"
							class="btn-block">
							${btnText}</a>
					</div>

					<div id="cart-items">
						${$(data).find('#cart-content #cart-items').html()}
					</div>
				`;

				($('#slide-cart-content').length)
					? slideCartContent.find('#slide-cart-content').html(slideCartHtml)
					: slideCartContent.prepend(`<div id="slide-cart-content" class="g-flex g-vertical">${slideCartHtml}</div>`);

				cartTotalUpdate();

				loadingBarTrigger('done');

				$('#slide-pane-overlay').unbind('mouseenter mousemove');

				// open cart
				(openCart && !html.is('#cart'))
					? cartTrigger.trigger('click') : '';

				(reloadPage)
					? location.reload() : '';

				if (callback) {
					callback();
				}
			}
		});
	}

	window.refreshCart = refreshCart;


	// cart add submissions
	$('form[action="/cart/add"]').submit(function(e) {
		e.preventDefault();

		let _this = $(this);
		let qty = _this.find('[name="quantity"]').length
			? _this.find('[name="quantity"]').val()
			: 1;

		loadingBarTrigger('start');

		itemAdd(_this.find('[name="variant"]:checked').val(), qty, true);
	});

	// quick add
	$('[data-quickadd-id]').click(function() {
		let _this = $(this);

		loadingBarTrigger('start');

		itemAdd(_this.attr('data-quickadd-id'), 1, 
			(!_this.closest('#slide-cart-content').length) ? true : false,
			(_this.closest('#cart-discover').length) ? true : false
		);
	});

	_document.on('change', '.item-quantity', function(e) {
		e.preventDefault();
		let _this = $(this);
		let item = _this.closest('.item');
		let quantityNew = _this.val();

		loadingBarTrigger('start');

		// sync both item selectors
		item.find('.item-info-quantity').val(quantityNew);

		// trigger ajax update
		itemUpdate(item.attr('data-item-id'), quantityNew, null);
	});

	_document.on('click', '.item-remove', function(e) {
		e.preventDefault();

		let _this = $(this);
		let item = _this.closest('.item');

		loadingBarTrigger('start');

		// remove item div
		item.fadeOut()
			.delay(300).remove();

		// trigger ajax update
		itemUpdate(item.attr('data-item-id'), 0, null);
	});

	_document.on('change', '#slide-cart-content .item-action-reveal select', function() {
		$(this).closest('.item').find('.item-edit').click();
	});

	_document.on('click', '.item-edit', function() {
		let _this = $(this);
		let item = _this.closest('.item');
		let itemId = item.attr('data-item-id');
		let itemVariants = item.find('.item-info-variants');
		let itemQuantity = item.find('.item-info-quantity');

		if(itemQuantity.val() != itemQuantity.attr('data-select-original')) {
			loadingBarTrigger('start');

			itemUpdate(itemId, itemQuantity.val(), null);

			itemQuantity.attr('data-select-original', itemQuantity.val());

			// if variant didn't change, then adjust quantity
			if(itemVariants.val() == itemVariants.attr('data-select-original')) {
				item.find('.item-quantity').val(itemQuantity.val());

				itemQuantity.find('option').each(function() {
					let option = $(this);

					option.text((option.is(':selected')) 
						? `QTY: ${option.text()}`
						: option.text().replace('QTY: ', ''));
				});
			}
		}

		if(itemVariants.val() != itemVariants.attr('data-select-original')) {
			loadingBarTrigger('start');

			// remove current variant ID
			itemUpdate(itemId, 0, 
				// then add new variant, with co-responding quantities
				function() {
					itemAdd(itemVariants.val(), itemQuantity.val(), 
						(!_this.closest('#slide-cart-content').length) ? true : false
					);
				}
			);

			// update item ID and variant text selected variant
			item.attr('data-item-id', itemVariants.val());

			item.find('.item-info-variant-current').text(itemVariants.find('option:selected').text());

			itemVariants.attr('data-select-original', itemVariants.val());
		}

		_this.toggleText('Edit', 'Done');
		item.find('.item-action-reveal').toggleClass('active');
	});

	$('.add_all').on('click', (e) => {
		const trg = $(e.target || e.currentTarget);
		const productsToAdd = trg.parent().find('BUTTON.quick-add-trigger[data-quickadd-id]');
		const itemsIds = [];
		let itemsToAdd = [];

		loadingBarTrigger('start');
		
		for (let i = 0; i < productsToAdd.length; i++) {
			const _id = $(productsToAdd[i]).attr('data-quickadd-id');

			if (itemsIds.indexOf(_id) === -1) {
				itemsIds.push(_id);
			}
		}

		itemsToAdd = itemsIds.map((_uid) => {
			return {
				id: _uid,
				quantity: 1
			}
		});

		bulkAdd(itemsToAdd);
	})

	excludeProductDiscover();
}

const initCxPage = () => {
	// content page selection
	const contentSidebar = $('#cx-content-sidebar');
	const contentsidebarLiA = contentSidebar.find('a');
	const contentPage = $('#cx-content-page');

	contentsidebarLiA.click(function(e) {
		e.preventDefault();
		let _this = $(this);
		let pageContent = $(`[data-page-content="${_this.attr('href').replace('#', '')}"]`);

		// assign active states
		_this.addClass('active')
			.closest('li').siblings()
			.find('a').removeClass('active');

		pageContent.addClass('active')
			.siblings().removeClass('active');

		// adjust content height
		contentPage.height(contentPage.height());

		setTimeout(function() {
			contentPage.height(pageContent.height());
		}, 1);

		setTimeout(function() {
			contentPage.height('auto');
		}, 601);

		// update window hash
		history.pushState(null, null, _this.attr('href'));
	});

	if(window.location.hash && 
		$(`[data-page-content="${window.location.hash.replace('#', '')}"]`).length) {
		contentSidebar.find(`a[href="${window.location.hash}"]`).click();
	}

	// faq expand
	$('#cx-content-sidebar a').click(function(e) {
		e.preventDefault();
		e.stopPropagation();
	});

	// faq expand
	$('.faq-question').click(function(e) {
		e.preventDefault();
		$(this).siblings('.faq-answer').slideToggle()
			.closest('.faq').toggleClass('active')
			.siblings().removeClass('active')
			.find('.faq-answer').slideUp();
	});

	// faq expand
	$('.accordion-title').click(function(e) {
		e.preventDefault();
		$(this).siblings('.accordion-content').slideToggle()
			.closest('.accordion').toggleClass('active')
			.siblings().removeClass('active')
			.find('.accordion-content').slideUp();
	});
}

const initIngredientsPage = () => {
	const groupsHeader = $('#ingredients-groups-header');
	const groupsHeaderButton = groupsHeader.find('button');
	const groupsContent = $('#ingredients-groups-content');
	const groupHeaderScrollUl = groupsHeader.find('#ingredients-groups-header-scroll ul');

	if (groupHeaderScrollUl.length > 0) {
		scrollable(groupHeaderScrollUl[0]);

		groupsHeaderButton.click(function() {
			let _this = $(this);
			let groupsContentActive = groupsContent.find(`[data-filter-group="${_this.attr('data-filter-group-trigger')}"]`);
	
			_this.addClass('active')
				.closest('li').siblings().find('button')
				.removeClass('active');
	
			groupsContentActive.addClass('active')
				.siblings().removeClass('active');
	
			groupsContent.height(groupsContentActive.height());
		})
	
		siteReadyTrigger(function() {
			groupsHeaderButton.first().click();
		});
	
		$('.ingredient').mouseenter(function() {
			let _this = $(this);
			let contentHeight = 10*2 + 20*2 + _this.find('.t-h-4').height() + 10 + _this.find('.ingredient-content').height();
	
			_this.find('.ingredient-bg').height((contentHeight > 240)
				? contentHeight : 240);
		}).mouseleave(function() {
			$(this).find('.ingredient-bg').height(220);
		});
	}
}

const initSimpleTabs = () => {
	const tabsButtons = $('.tabs-buttons-list li button');
	
	tabsButtons.on('click', (e) => {
		const trg = $(e.target || e.currentTarget);
		const bindedTabLabel = trg.attr('data-tab-trigger');
		const bindedTab = $('[data-tab="'+bindedTabLabel+'"]');

		trg.closest('ul').find('button').removeClass('active');
		trg.addClass('active');
		bindedTab.addClass('active').siblings().removeClass('active');
	})
}

const initCompLinkGroups = () => {
	$('.comp-link-groups .t-h-6').click(function() {
		$(this).siblings('ul').slideToggle(200)
			.closest('li').toggleClass('active')
			.siblings().removeClass('active')
			.find('ul').slideUp(200);
	});
}

const initCompTestimonials = () => {
	$('.comp-testimonials').each(function() {
		let _this = $(this);
		let content = _this.find('.comp-testimonials-content');
		let contentTestimonial = _this.find('.testimonial');
		let paginationButtons = _this.find('[data-paginate]');

		paginationButtons.click(function() {
			let paginate = $(this).attr('data-paginate');
			let currentTestimonialIndex = content.find('.active').index();
			let activeTestimonialIndex = (paginate == 'next')
				? currentTestimonialIndex < contentTestimonial.length - 1
					? currentTestimonialIndex + 1
					: 0
				: currentTestimonialIndex == 0
					? contentTestimonial.length - 1
					: currentTestimonialIndex - 1

			$(contentTestimonial[activeTestimonialIndex]).addClass('active')
				.siblings().removeClass('active');
		});
	});
}

const initProductScroll = () => {
	//desktop scroll effect
	const section = document.querySelector('.product-scroll-section');
  if (!section) return;
	const images = section.querySelectorAll('.product-scroll-image');
	const contents = section.querySelectorAll('.product-scroll-content');
	let currentIndex = 0;

	function updateScroll() {
		const scrollPosition = window.scrollY;
		const sectionTop = section.offsetTop;
		const sectionHeight = section.offsetHeight;
		const windowHeight = window.innerHeight;

		const scrollPercentage = (scrollPosition - sectionTop + windowHeight) / sectionHeight;

		if (scrollPercentage >= 0) {
			const newIndex = Math.min(Math.floor(scrollPercentage * 0.43 * images.length), images.length - 1);
			if (newIndex !== currentIndex) {
				images[currentIndex].classList.remove('opacity-100');
				images[currentIndex].classList.add('opacity-0');
				contents[currentIndex].classList.remove('opacity-100');
				contents[currentIndex].classList.add('opacity-40');

				images[newIndex].classList.remove('opacity-0');
				images[newIndex].classList.add('opacity-100');
				contents[newIndex].classList.remove('opacity-40');
				contents[newIndex].classList.add('opacity-100');

				currentIndex = newIndex;
			}
		}
	}

	window.addEventListener('scroll', updateScroll);
	updateScroll();

	//mobile carousel
	$('.product-scroll-carousel').each(function() {
		let _this = $(this);
		let content = _this.find('.product-scroll-carousel-content');
		let contentTestimonial = _this.find('.product-scroll-carousel-item');
		let paginationButtons = _this.find('[data-paginate]');

		paginationButtons.click(function() {
			let paginate = $(this).attr('data-paginate');
			let currentTestimonialIndex = content.find('.active').index();
			let activeTestimonialIndex = (paginate == 'next')
				? currentTestimonialIndex < contentTestimonial.length - 1
					? currentTestimonialIndex + 1
					: 0
				: currentTestimonialIndex == 0
					? contentTestimonial.length - 1
					: currentTestimonialIndex - 1

			$(contentTestimonial[activeTestimonialIndex]).addClass('active')
				.siblings().removeClass('active');
		});
	});
}

const initCompWorld = () => {
	$('.comp-world').each(function() {
		let _this = $(this);
		let iframe = _this.find('.comp-world-iframe');

		if(iframe.length) {
			const iframePlayer = new Vimeo.Player(iframe[0]);

			iframePlayer.on('play', function() {
				iframe.addClass('css_fadeIn');
			});

			setTimeout(function() {
				iframe.addClass('css_fadeIn');
			}, 3000);
		}
	});
}

const initAccounts = () => {
	// password reset
	const gateContent = $('#account-gate-content');
	const resetPasswordTrigger = $('#reset-password-trigger');
	const resetPasswordCancel = $('#reset-password-cancel');
	const resetPasswordField = $('#account-recover-email');

	resetPasswordTrigger.click(function(e) {
		e.preventDefault();

		html.addClass('reset_form_active');
		history.pushState(null, null, '#recover');

		resetPasswordField.focus();

		gateContent.height($('#account-reset-content').innerHeight());
	});

	resetPasswordCancel.click(function(e) {
		e.preventDefault();

		html.removeClass('reset_form_active');
		history.pushState(null, null, ' ');

		gateContent.height($('#account-login-content').innerHeight());
	});

	(window.location.hash == '#recover')
		? resetPasswordTrigger.trigger('click') : '';

	gateContent.height(gateContent.height());

	// address management
	const addressAddTrigger = $('#address-add-trigger');

	addressAddTrigger.click(function() {
		html.addClass('address_pop_active');

		$('#address-add').show();
	});
}

const initCompProductSlider = () => {
	$('.comp-product-slider').each(function() {
		let _this = $(this);
		let collection = _this.find('.comp-product-slider-collection');
		let collectionWidth = collection.width();
		let collectionProducts = collection.find('.comp-product-card');
		let collectionProductsWidth = collectionProducts.outerWidth(true);
		let collectionProductsLength = collectionProducts.length;
		let paginatePrev = _this.find('[data-paginate="prev"]');
		let paginateNext = _this.find('[data-paginate="next"]');
		let paginateIncrement = _this.find('.comp-product-slider-image').length
			? 2 : 3;

		let paginateTrigger = (paginate) => {
			let currentIndex = collection.find('.comp-product-card.active').index();
			let activeIndex = (paginate == 'next')
				? currentIndex < collectionProductsLength - 1
					? currentIndex + paginateIncrement
					: 0
				: currentIndex == 0
					? collectionProductsLength - paginateIncrement
					: currentIndex - paginateIncrement

			if(getComputedStyle(collection[0]).scrollBehavior === 'smooth') {
				collection.scrollLeft(collectionProductsWidth*activeIndex);
			} else {
				collection.animate({
					scrollLeft: collectionProductsWidth*activeIndex
				});
			}
		}
		paginatePrev.click(function() {
			paginateTrigger('prev')
		});
		paginateNext.click(function() {
			paginateTrigger('next')
		});

		let collectionReassignActive = () => {
			let scrollLeft = collection.scrollLeft();
			let activeIndex = Math.floor((scrollLeft + 10)/collectionProductsWidth) + 1;

			// assign active state for product
			$(collectionProducts[activeIndex]).addClass('active')
				.siblings().removeClass('active');

			// assign inactive state to paginatePrev
			(scrollLeft > 0)
				? paginatePrev.removeClass('inactive')
				: paginatePrev.addClass('inactive');

			// assign inactive state to paginateNext
			((scrollLeft + collectionWidth) >= (collectionProductsWidth - 1)*collectionProductsLength)
				? paginateNext.addClass('inactive')
				: paginateNext.removeClass('inactive');
		}
		siteReadyTrigger(collectionReassignActive);
		collection.scroll(collectionReassignActive);

		if(screenIsTablet) {
			let image = _this.find('.comp-product-slider-image');

			if(image.length) {
				_this.find('.comp-product-slider-header')
					.prepend(image.get(0).outerHTML)
					.addClass('g-flex g-center');

				image.remove();
			}

			_this.attr('data-paginate-position', 'bottom');
		}
	});
}

// 4.0 INIT APP

$('[data-scroll-to]').click(function() {
	scrollTo($(this).attr('data-scroll-to'));
});

(window.devicePixelRatio > 1)
	? html.addClass('screen_is_retina') : '';

keyOnPress = false;
_document.on('keydown', function() {
	keyOnPress = true;
}).on('keyup', function() {
	keyOnPress = false;
});

scrollTop = _window.scrollTop();
_window.on('scroll', function() {
	scrollTop = _window.scrollTop();
});

initFields();
initNewsletter();
initCurrencySelector();
initPageTransition();
initPageAnimation();
initHeader();
initSearchPane();
initCart();

initCompLinkGroups();
initCompTestimonials();
try {
  initProductScroll();
} catch (error) {
  console.log(error)
}
initCompWorld();
initCompProductSlider();

switch(html.attr('id')) {
	case 'frontpage':
		initFrontpage();
		break;

	case 'product-index':
		initProductIndex();
		break;

	case 'product-single':
		initProductSingle();
		initSimpleTabs();
		break;

	case 'page-customer-service':
	case 'page-landing-page':
	case 'page-rewards':
	case 'page-application-guidance': 
	case 'page-stockists': 
		initCxPage();
		break;

	case 'page-ingredients':
		initIngredientsPage();
		break;

	case 'accounts':
		initAccounts();
		break;

    default:
        initIngredientsPage();
}

_window.resize(function() {
	if ((!screenIsTablet && _window.width() < 1024) || 
		(screenIsTablet && _window.width() >= 1024) ||
		(!screenIsMobile && _window.width() < 600) || 
		(screenIsMobile && _window.width() >= 600)) {
		body.hide();
		location.reload();
	}
});



$(document).ready(function(){
  $(".shopify_leave_review .show_review").click(function(){
   $(".write-review-button").trigger("click");
  });
});

$(document).ready(function(){   
  if ($('.ingredient')) {    
	$('.ingredient-content').hide();
    $('.ingredient').on('click', function () {
      $(this).children('.ingredient-content').toggle('fast');      
      $(this).toggleClass('active');
    })
  }
});


$(document).ready(function(){
   setTimeout(function() { 
        if ($(".yotpo-regular-box").hasClass("yotpo-review")) {
          $(".shopify_leave_review").hide();
        }
    }, 2000); 
});



// SHOW MORE BUTTON

var products_on_page = $('.products-on-page');
var next_url = products_on_page.data('next-url');
var load_more_btn = $('.load-more_btn ');
var load_more_spinner = $('.load-more_spinner');

function loadMoreProducts() {
  $.ajax(
    {
      url: next_url,
      type: 'GET',
      dataType: 'html',
      beforeSend: function(){
      	load_more_btn.hide();
        load_more_spinner.show();
      }

    }
  ).done(function(next_page){
	
    load_more_spinner.hide();
    
    var new_products = $(next_page).find('.products-on-page');
    var new_url = new_products.data('next-url');
    
    if(new_url)
      load_more_btn.show();

    next_url = new_url;
    products_on_page.append(new_products.html());

  })

}


